export default __webpack_public_path__ + "static/media/error.cdb172c7.svg";